import { Component, OnInit } from '@angular/core';
import { UsersService} from "./users.service";
import { User} from "./user.model";
import { Router } from '@angular/router';
import { MessagesService } from "../../messages.service";

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})
export class UsersComponent implements OnInit {

  public users:User[];
  public loading : boolean;  
    
  constructor(private usersService: UsersService,private router: Router,private messagesService:MessagesService) { }

  ngOnInit() {
      this.users = [];
      this.loadUsers();
  }
    
    private loadUsers():void{
        this.loading = true;
        this.usersService.getAllUsers().subscribe(
        data => {this.loading = false;this.users=data},
        error => { this.loading = false; this.checkError(error,"Ha ocurrido un error al cargar los usuarios") }
      );
    }
    
    inactive(user:User){
        this.usersService.inactive(user.id,user.version).subscribe(
            data => this.loadUsers(),
            error => { this.checkError(error,"Ha ocurrido un error al inactivar el usuario") }
            );
    }
    
    active(user:User){
        this.usersService.active(user.id,user.version).subscribe(
            data => this.loadUsers(),
            error => { this.checkError(error,"Ha ocurrido un error al activar el usuario") }
            );
    }
    
    private checkError(error: any, defaultMessage: string) {
        this.messagesService.checkError(error,defaultMessage);
    }
    
}
